"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipTitle = void 0;
const react_1 = __importDefault(require("react"));
const tooltip_title_styles_1 = require("./tooltip-title.styles");
const TooltipTitle = ({ children }) => (react_1.default.createElement(tooltip_title_styles_1.StyledTooltipTitle, null, children));
exports.TooltipTitle = TooltipTitle;
exports.default = exports.TooltipTitle;
